import { render, staticRenderFns } from "./DailyStats.vue?vue&type=template&id=01dc61c7&"
import script from "./DailyStats.vue?vue&type=script&lang=ts&"
export * from "./DailyStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports